// @ts-nocheck
import { getMainPage, GetMainPageRequest } from '@yandex-int/k-common/client/api/defs/get-main-page';
import { getExperimentTestIds } from 'platform-components';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';

import { getCurrentDateFromSearch } from 'utils/get-current-date-from-search';

import { mainPageActions } from './actions';

export function* mainPageSagasWatcher() {
    yield all([takeEvery(mainPageActions.getMainPageRequest, getMainPageSaga)]);
}

function* getMainPageSaga(action: ReturnType<typeof mainPageActions.getMainPageRequest>) {
    const { grade } = action.payload;

    try {
        const date = getCurrentDateFromSearch() || new Date().toISOString().split('T')[0];

        const pageRequestParams: GetMainPageRequest = {
            grade,
            date,
        };

        const experimentTestIds: number[] = yield select(getExperimentTestIds);

        if (experimentTestIds.length) {
            pageRequestParams.experiments = experimentTestIds;
        }

        const { page } = yield call(getMainPage, pageRequestParams);

        yield put(
            mainPageActions.getMainPageSuccess({
                grade,
                page,
            })
        );
    } catch (error) {
        if (error.status === 404) {
            yield put(
                mainPageActions.getMainPageSuccess({
                    grade,
                    page: null,
                })
            );
            return;
        }

        console.error(error);
    }
}
